import { useEffect, useState } from 'react';

import baseApi from '../../api/baseApi';

import { getDataFromResponse, setErrorStatus } from '../../utils';

const useFetch = (request, refetchTrigger = null, alreadyFetchedData = null) => {
    const [data, setData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [error, setError] = useState(null);
    const [isMounted, setIsMounted] = useState(false);
    const [key, setKey] = useState(refetchTrigger);

    useEffect(() => {
        if (alreadyFetchedData || isMounted || !request) {
            return;
        }

        const fetch = () => baseApi.get(request.url, request.params && { params: request.params })
            .then(getDataFromResponse)
            .then(setData)
            .catch(error => setErrorStatus(setError, error))
            .finally(() => setIsFetching(false));

        if (refetchTrigger) {
            setIsFetching(true);
            setData([]);
        }

        setError(null);
        setIsMounted(true);
        fetch();
    }, [alreadyFetchedData, request, isMounted, refetchTrigger]);

    useEffect(() => {
        if (alreadyFetchedData || !refetchTrigger || !key || key === refetchTrigger) {
            return;
        }

        setKey(refetchTrigger);
        setIsMounted(false);
    }, [alreadyFetchedData, refetchTrigger, key]);

    if (alreadyFetchedData) {
        return [alreadyFetchedData, false, null];
    }

    return [
        data,
        isFetching,
        error
    ];
};

export default useFetch;
